export const FEMALE_PRICE = 1000;
export const MALE_PRICE = 700;

export const DEFAULT_BREED = 'Teacup Chihuahua';

export const priceForSex = (sex) => (String(sex).toLowerCase() === 'male' ? MALE_PRICE : FEMALE_PRICE);

export const CATALOGUE_PETS = [
  {
    id: 'cat-karma',
    title: 'Karma',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-01.jpeg'],
    description: 'Confident little explorer with bright eyes — ready to bond fast and love big.'
  },
  {
    id: 'cat-birkin',
    title: 'Birkin',
    sex: 'Male',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Male'),
    images: ['/images/catalogue/cat-02.jpeg'],
    description: 'Tiny gentleman with a calm, curious vibe — perfect for a cozy, loving home.'
  },
  {
    id: 'cat-gucci',
    title: 'Gucci',
    sex: 'Male',
    breed: DEFAULT_BREED,
    status: 'Sold',
    price: priceForSex('Male'),
    images: ['/images/catalogue/cat-03.jpeg'],
    description: 'Sweet cuddle buddy energy with a playful spark — the kind of pup you miss when you leave.'
  },
  {
    id: 'cat-nara',
    title: 'Nara',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-04.jpeg'],
    description: 'Soft, gentle, and super affectionate — a little heart-stealer who loves attention.'
  },
  {
    id: 'cat-penny',
    title: 'Penny',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-05.jpeg'],
    description: 'Big personality in a small body — alert, adorable, and always ready for hugs.'
  },
  {
    id: 'cat-cairo',
    title: 'Cairo',
    sex: 'Male',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Male'),
    images: ['/images/catalogue/cat-06.jpeg'],
    description: 'A little show-stopper with gentle confidence — raised with care and ready for a forever home.'
  },
  {
    id: 'cat-bailey',
    title: 'Bailey',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-07.jpeg'],
    description: 'Pocket-sized sweetheart who loves being close — perfect for snuggles and companionship.'
  },
  {
    id: 'cat-harlow',
    title: 'Harlow',
    sex: 'Male',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Male'),
    images: ['/images/catalogue/cat-08.jpeg'],
    description: 'Little fashion icon in a cozy sweater — playful, expressive, and ready to be spoiled.'
  },
  {
    id: 'cat-missy',
    title: 'Missy',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-09.jpeg'],
    description: 'Tiny and sweet with bright eyes — gentle cuddle buddy energy for a calm home.'
  },
  {
    id: 'cat-milan',
    title: 'Milan',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-10.jpeg'],
    description: 'Confident little sweetheart who loves being held — perfect for snuggles and selfies.'
  },
  {
    id: 'cat-bella',
    title: 'Bella',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-11.jpeg'],
    description: 'Elegant and affectionate — the kind of pup that instantly becomes family.'
  },
  {
    id: 'cat-nori',
    title: 'Nori',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-12.jpeg'],
    description: 'Big eyes, tiny paws, and a gentle vibe — perfect for apartment living.'
  },
  {
    id: 'cat-dopey',
    title: 'Dopey',
    sex: 'Male',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Male'),
    images: ['/images/catalogue/cat-13.jpeg'],
    description: 'Curious and calm with a sweet personality — a loyal little lap dog in the making.'
  },
  {
    id: 'cat-sasha',
    title: 'Sasha',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-14.jpeg'],
    description: 'Sweet, expressive, and ready for love — raised with care and thoughtful socialization.'
  },
  {
    id: 'cat-max',
    title: 'Max',
    sex: 'Male',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Male'),
    images: ['/images/catalogue/cat-15.jpeg'],
    description: 'Bold little explorer — playful energy with a gentle, people-focused heart.'
  },
  {
    id: 'cat-karma-2',
    title: 'Karma',
    sex: 'Female',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Female'),
    images: ['/images/catalogue/cat-16.jpeg'],
    description: 'Snowy-soft and sweet — a tiny companion who loves closeness and calm routines.'
  },
  {
    id: 'cat-birkin-2',
    title: 'Birkin',
    sex: 'Male',
    breed: DEFAULT_BREED,
    status: 'Available',
    price: priceForSex('Male'),
    images: ['/images/catalogue/cat-17.jpeg'],
    description: 'Gentle and attentive — ready to bond quickly and follow you everywhere.'
  }
];

export const getDefaultPets = () =>
  CATALOGUE_PETS.map((p) => ({
    ...p,
    age: 'Ask for details',
    weight: 'Ask for details',
    size: 'Ask for details'
  }));

export const mergePets = (storedPets, defaultPets) => {
  const byId = new Map(defaultPets.map((p) => [p.id, p]));
  const merged = [];

  for (const def of defaultPets) {
    const found = storedPets.find((p) => p.id === def.id);
    merged.push(found ? { ...def, ...found } : def);
  }

  for (const extra of storedPets) {
    if (!byId.has(extra.id)) merged.push(extra);
  }

  return merged;
};
